/**
 * <s-cart-timer minutes="10"> — cart reservation countdown.
 * The end time is kept in sessionStorage so it survives drawer refreshes and page loads.
 * When it runs out it shows the [data-expired] message instead of restarting.
 */
class SCartTimer extends HTMLElement {
  #interval;

  connectedCallback() {
    const minutes = Number(this.getAttribute('minutes')) || 10;
    const key = 's-cart-timer-end';
    let end = Number(sessionStorage.getItem(key));
    if (!end) {
      end = Date.now() + minutes * 60 * 1000;
      sessionStorage.setItem(key, String(end));
    }
    this.#tick(end);
    this.#interval = setInterval(() => this.#tick(end), 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#interval);
  }

  #tick(end) {
    const output = this.querySelector('[data-time]');
    const remaining = Math.max(0, end - Date.now());
    if (remaining === 0) {
      clearInterval(this.#interval);
      this.querySelector('[data-running]')?.setAttribute('hidden', '');
      this.querySelector('[data-expired]')?.removeAttribute('hidden');
      return;
    }
    const totalSeconds = Math.ceil(remaining / 1000);
    const mm = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
    const ss = String(totalSeconds % 60).padStart(2, '0');
    if (output) output.textContent = `${mm}:${ss}`;
  }
}

if (!customElements.get('s-cart-timer')) customElements.define('s-cart-timer', SCartTimer);
